import { api } from '@/api/ApiGateway'

class SupportMessageApi
{
	insert(supportMessage, onSuccess, onError)
	{
		api.post('users/support/message', supportMessage).then(response =>
		{
			if (response.hasError())
			{
				onError(response)
				return
			}
			try
			{
				onSuccess(response)
			}
			catch (e)
			{
				response.overrideError({ detail: `${e}` })
				onError(response)
			}
		})
	}
}

export const supportMessageApi = new SupportMessageApi()